<template>
  <div class="invoice-wrap h-100">
    <cus-button
      v-for="(item, index) in invoiceBtns"
      :key="index"
      :text="item.label.textBreak(5)"
      color="whiteYellow"
      @click="handleClick(item.click, item)"
      :disabled="!handleDisable(item.checkDisable, item) || getOrderAmount === 0"
      :textClass="index === 1 ? 'text-small' : ''"
    ></cus-button>
  </div>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { computed, getCurrentInstance, defineAsyncComponent } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useDialog } from '@/utils/dialog';
import { getInvoiceButtons } from '@/utils/define';
export default {
  name: 'invoice',
  props: ['selectItem', 'number'],
  emits: ['update:selectItem', 'update:number'],
  components: {
    Alert: defineAsyncComponent(() => import('@/components/dialog/Alert.vue')),
    InputInfo: defineAsyncComponent(() => import('@/components/dialog/InputInfo.vue')),
    Information: defineAsyncComponent(() => import('@/components/dialog/Information.vue')),
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得按鈕清單
    const invoiceBtns = getInvoiceButtons();
    //取得清單
    const { getCarrier, getInvoiceMode, getPaidList, getOrderAmount } = useGetters('checkout', [
      'getCarrier',
      'getInvoiceMode',
      'getPaidList',
      'getOrderAmount',
    ]);
    //執行function
    const handleClick = (event, value) => {
      proxy[event](value);
    };
    const handleDisable = (event, value) => {
      return proxy[event](value);
    };
    //*按鈕狀態-----------------------------------------------
    //取得付款type陣列
    const paidListType = computed(() => getPaidList.value.map((e) => e.type));
    //卡片載具
    const cardDisable = () => {
      if (getInvoiceMode.value === 2) return false;
      if (paidListType.value.includes(3) || paidListType.value.includes(4)) return true;
      return false;
    };
    //手機條碼/自然人憑證/捐贈碼
    const deviceDisable = () => {
      if (getInvoiceMode.value === 2) return false;
      return true;
    };
    //統編
    const taxDisable = () => {
      if (getInvoiceMode.value === 2) return false;
      return true;
    };
    //*點擊---------------------------------------------------
    //取得發票Type陣列
    const carrierListType = computed(() => getCarrier.value.map((e) => e.invoice_carrier_type));
    //統編
    const getTax = useGetters('checkout', ['getTax']);
    const DELETE_DEVICE = useMutations('checkout', ['DELETE_DEVICE']);
    const handleTax = (item) => {
      if (getTax.value) {
        openDialog('buyerTaxId');
        return;
      }
      if (carrierListType.value.includes('love_code') || carrierListType.value.includes('card_carrier')) {
        proxy
          .$confirm({
            content: `若打統編，發票將無法存入${
              carrierListType.value.includes('love_code') ? '捐贈發票' : '卡片載具'
            }，<br/>是否仍要輸入統編？`,
            confirmText: '輸入統編',
          })
          .then(() => {
            DELETE_DEVICE();
            context.emit('update:selectItem', item);
            context.emit('update:number', null);
          })
          .catch((e) => e);
      } else {
        context.emit('update:selectItem', item);
        context.emit('update:number', null);
      }
    };
    //清除統編
    const SET_TAX = useMutations('checkout', ['SET_TAX']);
    const clearTax = () => {
      SET_TAX('');
      closeDialog();
    };
    //手機條碼/自然人憑證/捐贈碼
    const doQueryDevice = useActions('checkout', ['doQueryDevice']);
    const handleDevice = async (item) => {
      // TODO:衝突提示
      try {
        const dialogData = {
          dialogContent: `請感應/掃描<br/>${item.label}`,
          submitFunc: 'openEnterCode',
        };
        const cusProps = {
          scanType: item.scanType,
          canEnter: true,
          canEnterText: '手動輸入',
        };
        openDialog('noticeScan', cusProps, dialogData);
        await doQueryDevice(item.scanType);
        closeDialog();
      } catch (error) {
        // error code 40101 -> 不關閉可手動輸入的掃描彈窗
        if (error.code !== '40101') closeDialog();
      }
    };
    //打開手動輸入
    const openEnterCode = (val) => {
      openDialog('enterCode', { scanType: val });
    };
    //手動輸入送出
    const doCheckCarrierNo = useActions('checkout', ['doCheckCarrierNo']);
    const handleEnterCode = async (data) => {
      await doCheckCarrierNo(data); //data edit in EnterCode.vue
      closeDialog();
    };
    //卡片載具
    const SET_CARRIER = useMutations('checkout', ['SET_CARRIER']);
    const handleCardDevice = () => {
      // TODO:衝突提示
      SET_CARRIER({ invoice_carrier_type: 'card_carrier' });
    };
    return {
      dialogTemplate,
      invoiceBtns,
      getOrderAmount,
      handleClick,
      handleDisable,
      deviceDisable,
      cardDisable,
      taxDisable,
      handleTax,
      clearTax,
      handleDevice,
      openEnterCode,
      handleEnterCode,
      handleCardDevice,
    };
  },
};
</script>
<style lang="scss" scoped>
.invoice-wrap {
  display: grid;
  grid-template-rows: repeat(4, 1fr);
}
:deep(.text-small) {
  font-size: 1.8rem;
}
</style>
